import { Link } from "react-router-dom";
import { styled } from "styled-components";


export const ContentStyled = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  gap: 32px;
  box-sizing: border-box;
`;

export const ContentItemStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 10px;
  .icon-complete {
    color: ${({ theme }) => theme?.colors?.theme?.success};
    font-size: 16px;
  }
  a {
    color: ${({ theme }) => theme?.colors?.theme?.info};
    fill: ${({ theme }) => theme?.colors?.theme?.info};
    text-decoration: underline;
  }
`;

export const ContentInfoPostStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  .title-invite{
    color: ${({ theme }) => theme?.colors?.theme?.info};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
  }
`;

export const TitleStyled = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme?.colors?.text?.headings};
`;

export const DescriptionStyled = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme?.colors?.theme?.info};
  flex: 1;
`;

export const TextLinkStyled = styled(Link)`
  margin: 0px;
  flex: 1;
  text-align: center;
  padding: 12px 0px;
  text-decoration: underline;
  color:  ${({ theme }) => theme?.colors?.text?.neutral};
`;

